export default "<app-menu-principal></app-menu-principal>\n  <router-outlet></router-outlet>\n<app-footer></app-footer>\n"